import { Language } from '../translations'

export const projectsTranslations: Record<string, Record<Language, string>> = {
  // Header and navigation
  'projects.title': {
    en: 'Projects',
    fi: 'Projektit'
  },
  'projects.experts': {
    en: 'Experts',
    fi: 'Asiantuntijat'
  },
  'projects.draft': {
    en: 'DRAFT',
    fi: 'LUONNOS'
  },
  'projects.new': {
    en: 'NEW',
    fi: 'UUSI'
  },
  'projects.expired': {
    en: 'EXPIRED',
    fi: 'VANHENTUNUT'
  },
  'projects.sync': {
    en: 'Sync',
    fi: 'Synkronoi'
  },
  'projects.syncMembers': {
    en: 'Sync members',
    fi: 'Synkronoi jäsenet'
  },
  'projects.syncMembersConfirm': {
    en: 'This will sync projects members with ValueFrame for this project and its subprojects.',
    fi: 'Tämä synkronoi projektin jäsenet ValueFramen kanssa tälle projektille ja sen osaprojekteille.'
  },
  'projects.syncMembersSuccess': {
    en: 'Project members synced with ValueFrame',
    fi: 'Projektin jäsenet synkronoitu ValueFrameen'
  },
  'projects.syncMembersFailure': {
    en: 'Failed to sync project members',
    fi: 'Projektin jäsenten synkronointi epäonnistui'
  },
  'projects.newProjectDraft': {
    en: 'New Project Draft',
    fi: 'Uusi projektiluonnos'
  },
  'projects.customers': {
    en: 'Customers',
    fi: 'Asiakkaat'
  },
  'projects.addCustomer': {
    en: 'Add Customer',
    fi: 'Lisää asiakas'
  },
  'projects.addProject': {
    en: 'Add Project',
    fi: 'Lisää projekti'
  },
  'projects.deleteProject': {
    en: 'Delete Project',
    fi: 'Poista projekti'
  },

  // Form labels and placeholders
  'projects.editProject': {
    en: 'Edit Project Draft',
    fi: 'Muokkaa projektiluonnosta'
  },
  'projects.customer': {
    en: 'Customer',
    fi: 'Asiakas'
  },
  'projects.customerName': {
    en: 'Customer Name',
    fi: 'Asiakkaan nimi'
  },
  'projects.customerNameRequired': {
    en: 'Customer name is required',
    fi: 'Asiakkaan nimi on pakollinen'
  },
  'projects.customerManager': {
    en: 'Customer Manager',
    fi: 'Asiakasvastaava'
  },
  'projects.project': {
    en: 'project',
    fi: 'projekti'
  },
  'projects.projects': {
    en: 'projects',
    fi: 'projektia'
  },
  'projects.projectName': {
    en: 'Project Name',
    fi: 'Projektin nimi'
  },
  'projects.selectCustomer': {
    en: 'Select customer',
    fi: 'Valitse asiakas'
  },
  'projects.startDate': {
    en: 'Start Date',
    fi: 'Aloituspäivä'
  },
  'projects.endDate': {
    en: 'End Date',
    fi: 'Lopetuspäivä'
  },
  'projects.expirationDate': {
    en: 'Expiration Date',
    fi: 'Vanhentumispäivä'
  },
  'projects.start': {
    en: 'Start',
    fi: 'Aloitus'
  },
  'projects.end': {
    en: 'End',
    fi: 'Lopetus'
  },
  'projects.expiration': {
    en: 'Expiration',
    fi: 'Vanhentuminen'
  },
  'projects.value': {
    en: 'Value',
    fi: 'Arvo'
  },
  'projects.projectValue': {
    en: 'Project value',
    fi: 'Projektin arvo'
  },
  'projects.additionalInformation': {
    en: 'Info',
    fi: 'Tiedot'
  },
  'projects.additionalInfoPlaceholder': {
    en: 'Project info',
    fi: 'Projektin tiedot'
  },

  // Dialog titles
  'projects.editCustomer': {
    en: 'Edit Customer',
    fi: 'Muokkaa asiakasta'
  },
  'projects.deleteCustomer': {
    en: 'Delete Customer',
    fi: 'Poista asiakas'
  },
  'projects.editProjectDraft': {
    en: 'Edit Project Draft',
    fi: 'Muokkaa projektiluonnosta'
  },
  'projects.addTeamMember': {
    en: 'Add team member',
    fi: 'Lisää tiimin jäsen'
  },

  // Member management
  'projects.projectMembers': {
    en: 'Project Members',
    fi: 'Projektin jäsenet'
  },
  'projects.members': {
    en: 'members',
    fi: 'jäsentä'
  },
  'projects.expert': {
    en: 'Expert',
    fi: 'Asiantuntija'
  },
  'projects.selectExpert': {
    en: 'Select expert',
    fi: 'Valitse asiantuntija'
  },
  'projects.role': {
    en: 'Role',
    fi: 'Rooli'
  },
  'projects.selectRole': {
    en: 'Select role',
    fi: 'Valitse rooli'
  },
  'projects.rolePlaceholder': {
    en: 'e.g., Developer',
    fi: 'esim. Kehittäjä'
  },
  'projects.roleDetailedPlaceholder': {
    en: 'e.g., Developer, Designer, Project Manager',
    fi: 'esim. Kehittäjä, Suunnittelija, Projektipäällikkö'
  },
  'projects.fullTime': {
    en: 'Full Time',
    fi: 'Kokoaikainen'
  },
  'projects.partTime': {
    en: 'Part Time',
    fi: 'Osa-aikainen'
  },
  'projects.addMember': {
    en: 'Add Member',
    fi: 'Lisää jäsen'
  },
  'projects.addedMembers': {
    en: 'Added Members',
    fi: 'Lisätyt jäsenet'
  },
  'projects.dragExpertsHere': {
    en: 'Drag experts here to add them to the project',
    fi: 'Vedä asiantuntijoita tähän lisätäksesi heidät projektiin'
  },

  // Subproject management
  'projects.subprojects': {
    en: 'Subprojects',
    fi: 'Osaprojektit'
  },
  'projects.selectSubproject': {
    en: 'Select subproject',
    fi: 'Valitse osaprojekti'
  },

  // Buttons
  'projects.cancel': {
    en: 'Cancel',
    fi: 'Peruuta'
  },
  'projects.create': {
    en: 'Create',
    fi: 'Luo'
  },
  'projects.update': {
    en: 'Update',
    fi: 'Päivitä'
  },
  'projects.delete': {
    en: 'Delete',
    fi: 'Poista'
  },

  // Status and info
  'projects.created': {
    en: 'Created',
    fi: 'Luotu'
  },
  'projects.updated': {
    en: 'Updated',
    fi: 'Päivitetty'
  },
  'projects.projectDetails': {
    en: 'Project Details',
    fi: 'Projektin tiedot'
  },
  'projects.info': {
    en: 'Info',
    fi: 'Tiedot'
  },

  // Messages
  'projects.noCustomersFound': {
    en: 'No customers found. Create your first customer to get started.',
    fi: 'Asiakkaita ei löytynyt. Luo ensimmäinen asiakkaasi aloittaaksesi.'
  },
  'projects.noProjectsFound': {
    en: 'No projects found.',
    fi: 'Projekteja ei löytynyt.'
  },
  'projects.requiredFields': {
    en: 'Customer, project name, and start date are required',
    fi: 'Asiakas, projektin nimi ja aloituspäivä ovat pakollisia'
  },
  'projects.selectExpertAndRole': {
    en: 'Please select an expert and provide a role',
    fi: 'Valitse asiantuntija ja anna rooli'
  },
  'projects.expertAlreadyAdded': {
    en: 'This expert is already added to the project',
    fi: 'Tämä asiantuntija on jo lisätty projektiin'
  },

  // Success messages
  'projects.customerCreated': {
    en: 'Customer created successfully',
    fi: 'Asiakas luotu onnistuneesti'
  },
  'projects.customerUpdated': {
    en: 'Customer updated successfully',
    fi: 'Asiakas päivitetty onnistuneesti'
  },
  'projects.customerDeleted': {
    en: 'Customer deleted successfully',
    fi: 'Asiakas poistettu onnistuneesti'
  },
  'projects.projectUpdated': {
    en: 'Project draft updated successfully',
    fi: 'Projektiluonnos päivitetty onnistuneesti'
  },
  'projects.projectCreated': {
    en: 'Project draft created successfully',
    fi: 'Projektiluonnos luotu onnistuneesti'
  },
  'projects.projectDeleted': {
    en: 'Project draft deleted successfully',
    fi: 'Projektiluonnos poistettu onnistuneesti'
  },
  'projects.memberAdded': {
    en: 'Member added to project successfully',
    fi: 'Jäsen lisätty projektiin onnistuneesti'
  },
  'projects.memberRemoved': {
    en: 'Member removed from project successfully',
    fi: 'Jäsen poistettu projektista onnistuneesti'
  },
  'projects.memberMoved': {
    en: 'Member moved to project successfully',
    fi: 'Jäsen siirretty projektiin onnistuneesti'
  },
  'projects.memberCopied': {
    en: 'Member copied to project successfully',
    fi: 'Jäsen kopioitu projektiin onnistuneesti'
  },
  'projects.moveOrCopyMember': {
    en: 'Move or Copy Member',
    fi: 'Siirrä tai kopioi jäsen'
  },
  'projects.moveOrCopyDescription': {
    en: 'Would you like to move or copy this member to the target project?',
    fi: 'Haluatko siirtää vai kopioida tämän jäsenen kohdeprojektiin?'
  },
  'projects.moveMember': {
    en: 'Move',
    fi: 'Siirrä'
  },
  'projects.copyMember': {
    en: 'Copy',
    fi: 'Kopioi'
  },

  // Delete confirmation
  'projects.deleteProjectDraft': {
    en: 'Delete Project Draft',
    fi: 'Poista projektiluonnos'
  },
  'projects.deleteConfirmation': {
    en: 'Are you sure you want to delete this project draft? This action cannot be undone.',
    fi: 'Oletko varma, että haluat poistaa tämän projektiluonnoksen? Tätä toimintoa ei voi peruuttaa.'
  },
  'projects.deleteCustomerConfirmation': {
    en: 'Are you sure you want to delete this customer? This action cannot be undone.',
    fi: 'Oletko varma, että haluat poistaa tämän asiakkaan? Tätä toimintoa ei voi peruuttaa.'
  },

  // Error messages
  'projects.error': {
    en: 'Error',
    fi: 'Virhe'
  },
  'projects.success': {
    en: 'Success',
    fi: 'Onnistui'
  },

  // Transfers view translations
  'projects.transfers.title': {
    en: 'Transfers',
    fi: 'Siirrot'
  },
  'projects.transfers.lastAnalyzed': {
    en: 'Last analyzed',
    fi: 'Viimeksi analysoitu'
  },
  'projects.transfers.refresh': {
    en: 'Refresh',
    fi: 'Päivitä'
  },
  'projects.transfers.noDataAvailable': {
    en: 'No transfer data available',
    fi: 'Siirtotietoja ei ole saatavilla'
  },
  'projects.transfers.totalChanges': {
    en: 'Total Changes',
    fi: 'Muutoksia yhteensä'
  },
  'projects.transfers.additions': {
    en: 'Additions',
    fi: 'Lisäykset'
  },
  'projects.transfers.transfers': {
    en: 'Transfers',
    fi: 'Siirrot'
  },
  'projects.transfers.removals': {
    en: 'Removals',
    fi: 'Poistot'
  },
  'projects.transfers.noTransfersFound': {
    en: 'No transfers found',
    fi: 'Siirtoja ei löytynyt'
  },
  'projects.transfers.noTransfersDescription': {
    en: 'All project members are synchronized between the internal database and ValueFrame',
    fi: 'Kaikki projektin jäsenet ovat synkronoituja sisäisen tietokannan ja ValueFramen välillä'
  },
  'projects.transfers.from': {
    en: 'From',
    fi: 'Projektista'
  },
  'projects.transfers.to': {
    en: 'To',
    fi: 'Projektiin'
  },
  'projects.transfers.addition': {
    en: 'Addition',
    fi: 'Lisäys'
  },
  'projects.transfers.removal': {
    en: 'Removal',
    fi: 'Poisto'
  },
  'projects.transfers.transfer': {
    en: 'Transfer',
    fi: 'Siirto'
  },

  'projects.searchExperts': {
    en: 'Find experts',
    fi: 'Hae asiantuntijoita'
  },
  'projects.foundFor': {
    en: 'found for',
    fi: 'löydetty hakusanoilla'
  },
  'projects.searching': {
    en: 'Searching...',
    fi: 'Haetaan...'
  },
  'projects.search': {
    en: 'Search',
    fi: 'Hae'
  },
  'projects.expertFound': {
    en: 'expert',
    fi: 'asiantuntija'
  },
  'projects.expertsFound': {
    en: 'experts',
    fi: 'asiantuntijaa'
  },
  'projects.transfers.revertAllChanges': {
    en: 'Revert All Changes',
    fi: 'Tyhjennä kaikki muutokset'
  },
  'projects.transfers.revertConfirmTitle': {
    en: 'Confirm Revert All Changes',
    fi: 'Vahvista kaikkien muutosten tyhjennys'
  },
  'projects.transfers.revertConfirmDescription': {
    en: 'This will revert all local changes and re-sync with ValueFrame. This action cannot be undone. Are you sure you want to continue?',
    fi: 'Tämä tyhjentää kaikki paikalliset muutokset ja synkronoi uudelleen ValueFramen kanssa. Tätä toimintoa ei voi peruuttaa. Oletko varma, että haluat jatkaa?'
  },
  'projects.transfers.revertSuccess': {
    en: 'All changes reverted successfully',
    fi: 'Kaikki muutokset tyhjennetty onnistuneesti'
  },
  'projects.transfers.revertError': {
    en: 'Failed to revert changes',
    fi: 'Muutosten tyhjennys epäonnistui'
  },
  'projects.transfers.reverting': {
    en: 'Reverting changes...',
    fi: 'Tyhjennetään muutoksia...'
  },
  'projects.transfers.cancel': {
    en: 'Cancel',
    fi: 'Peruuta'
  },
  'projects.transfers.confirm': {
    en: 'Confirm Revert',
    fi: 'Vahvista muutosten tyhjennys'
  },

  // Filter translations
  'projects.filters.title': {
    en: 'Filters',
    fi: 'Suodattimet'
  },
  'projects.filters.filterBy': {
    en: 'Filter by',
    fi: 'Suodata'
  },
  'projects.filters.customers': {
    en: 'Customers',
    fi: 'Asiakkaat'
  },
  'projects.filters.projects': {
    en: 'Projects',
    fi: 'Projektit'
  },
  'projects.filters.selectCustomers': {
    en: 'Select Customers',
    fi: 'Valitse asiakkaat'
  },
  'projects.filters.selectProjects': {
    en: 'Select Projects',
    fi: 'Valitse projektit'
  },
  'projects.filters.selectAll': {
    en: 'Select All',
    fi: 'Valitse kaikki'
  },
  'projects.filters.clearAll': {
    en: 'Clear All',
    fi: 'Tyhjennä kaikki'
  },
  'projects.filters.customersSelected': {
    en: 'customers selected',
    fi: 'asiakasta valittu'
  },
  'projects.filters.projectsSelected': {
    en: 'projects selected',
    fi: 'projektia valittu'
  },

  // Show transfers translations
  'projects.showTransfers': {
    en: 'Show Transfers',
    fi: 'Näytä siirrot'
  },
  'projects.hideTransfers': {
    en: 'Hide Transfers',
    fi: 'Piilota siirrot'
  },
  'projects.transfersLoading': {
    en: 'Loading transfers...',
    fi: 'Ladataan siirtoja...'
  },
  'projects.transfersError': {
    en: 'Failed to load transfers',
    fi: 'Siirtojen lataus epäonnistui'
  },
  'projects.team': {
    en: 'Team',
    fi: 'Tiimi'
  },

  // Expert Card specific translations
  'projects.expertDetails': {
    en: 'Expert Details',
    fi: 'Asiantuntijan tiedot'
  },
  'projects.currentProjects': {
    en: 'Current Projects',
    fi: 'Nykyiset projektit'
  },
  'projects.transfers': {
    en: 'Transfers',
    fi: 'Siirrot'
  },
  'projects.addition': {
    en: 'Addition',
    fi: 'Lisäys'
  },
  'projects.removal': {
    en: 'Removal',
    fi: 'Poisto'
  },
  'projects.transferFrom': {
    en: 'Transfer from',
    fi: 'Siirto projektista'
  },
  'projects.transferTo': {
    en: 'Transfer to',
    fi: 'Siirto projektiin'
  },
  'projects.expertInfo': {
    en: 'Expert Information',
    fi: 'Asiantuntijan tiedot'
  },
  'projects.expertInfoPlaceholder': {
    en: 'Add notes about this expert...',
    fi: 'Lisää muistiinpanoja tästä asiantuntijasta...'
  },
  'projects.highAttention': {
    en: 'Available Now',
    fi: 'Vapaana nyt'
  },
  'projects.expertUpdated': {
    en: 'Expert updated successfully',
    fi: 'Asiantuntija päivitetty onnistuneesti'
  },
  'projects.expertNotFound': {
    en: 'Expert not found',
    fi: 'Asiantuntijaa ei löytynyt'
  },
  'projects.loading': {
    en: 'Loading...',
    fi: 'Ladataan...'
  },
  'save': {
    en: 'Save',
    fi: 'Tallenna'
  },
  'projects.roles': {
    en: 'Roles',
    fi: 'Roolit'
  },
  'projects.availableNow': {
    en: 'Available now',
    fi: 'Vapaana nyt'
  },
  'projects.fullAllocation': {
    en: 'Full allocation',
    fi: 'Täysi allokaatio'
  },
  'projects.expandSidebar': {
    en: 'Expand sidebar',
    fi: 'Laajenna sivupalkki'
  },
  'projects.collapseSidebar': {
    en: 'Collapse sidebar',
    fi: 'Pienennnä sivupalkki'
  },

  // LogView specific translations
  'projects.viewLog': {
    en: 'View Log',
    fi: 'Näytä loki'
  },
  'projects.by': {
    en: ' by',
    fi: ', tehnyt'
  },
  'projects.backToDashboard': {
    en: 'Back to Dashboard',
    fi: 'Takaisin hallintapaneeliin'
  },
  'projects.noLogsFound': {
    en: 'No transfer logs found',
    fi: 'Siirtolokeja ei löytynyt'
  },
  'projects.noLogsDescription': {
    en: 'Transfer logs will appear here when members are moved between projects',
    fi: 'Siirtologit näkyvät täällä kun jäseniä siirretään projektien välillä'
  },

  'projects.exclude': {
    en: 'Exclude from allocations',
    fi: 'Jätä pois allokaatioista'
  },

  // Lock/Unlock translations
  'projects.lock': {
    en: 'Lock',
    fi: 'Lukitse'
  },
  'projects.unlock': {
    en: 'Unlock',
    fi: 'Avaa lukitus'
  },
  'projects.locked': {
    en: 'Locked',
    fi: 'Lukittu'
  },
  'projects.unlocked': {
    en: 'Unlocked',
    fi: 'Lukitsematon'
  },
  'projects.unlockProject': {
    en: 'Unlock Project',
    fi: 'Avaa projektin lukitus'
  },
  'projects.unlockProjectDescription': {
    en: 'Are you sure you want to unlock this project? This will allow editing and member transfers.',
    fi: 'Oletko varma, että haluat avata tämän projektin lukituksen? Tämä sallii muokkaamisen ja jäsenten siirrot.'
  },
  'projects.unlockMember': {
    en: 'Unlock Member',
    fi: 'Avaa jäsenen lukitus'
  },
  'projects.unlockMemberDescription': {
    en: 'Are you sure you want to unlock {name}? This will allow editing and transfers for this member.',
    fi: 'Oletko varma, että haluat avata käyttäjän {name} lukituksen? Tämä sallii tämän jäsenen muokkaamisen ja siirrot.'
  },
  'projects.cannotDropMember': {
    en: 'Cannot drop member',
    fi: 'Jäsentä ei voi pudottaa'
  },
  'projects.projectLockedMessage': {
    en: 'This project is locked. Unlock it first to add members.',
    fi: 'Tämä projekti on lukittu. Avaa lukitus ensin lisätäksesi jäseniä.'
  },

  'projects.column': {
    en: 'Column',
    fi: 'Sarake'
  },
  'projects.hideColumn': {
    en: 'Hide Column',
    fi: 'Piilota sarake'
  },
  'projects.showColumn': {
    en: 'Show Column',
    fi: 'Näytä sarake'
  },

  'projects.memberMissing': {
    en: 'Planned removal from project',
    fi: 'Suunniteltu siirto projektista pois'
  },
  'projects.memberAddedLocally': {
    en: 'Planned addition to project',
    fi: 'Suunniteltu siirto sisään projektiin'
  },
  'projects.memberNormal': {
    en: 'Allocated to project',
    fi: 'Resursoitu projektiin toistaiseksi'
  },


  'projects.results': {
    en: 'results for search query',
    fi: 'tulosta haulla'
  },

  // Event log translations
  'projects.events': {
    en: 'Events',
    fi: 'Tapahtumat'
  },
  'projects.systemMessage': {
    en: 'System Message',
    fi: 'Järjestelmäviesti'
  },
  'projects.integration': {
    en: 'Integration update',
    fi: 'Integraatiopäivitys'
  },
  'projects.eventDeleted': {
    en: 'deleted',
    fi: 'poisti'
  },
  'projects.eventCreated': {
    en: 'created',
    fi: 'loi'
  },
  'projects.eventProject': {
    en: 'project',
    fi: '-projektin'
  },
  'projects.eventDraft': {
    en: 'project draft',
    fi: '-luonnosprojektin'
  },
  'projects.addMessage': {
    en: 'Add Message',
    fi: 'Lisää viesti'
  },
  'projects.addMessagePlaceholder': {
    en: 'Enter your message here...',
    fi: 'Kirjoita viestisi tähän...'
  },
  'submitting': {
    en: 'Submitting...',
    fi: 'Lähetetään...'
  },
  'projects.noEvents': {
    en: 'No events found',
    fi: 'Tapahtumia ei löytynyt'
  },
  'projects.sendMessage': {
    en: 'Send Event Message',
    fi: 'Tapahtumaviestin lähetys'
  },

  'projects.markAsRead': {
    en: 'Mark as read',
    fi: 'Merkitse luetuksi'
  },
  'projects.markAllAsRead': {
    en: 'Mark all as read',
    fi: 'Merkitse kaikki luetuksi'
  }
};
